import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";
import type { RestrictionLifecycle } from "../_helpers/restrictionStatus";

const LIFECYCLE_LABEL: Record<RestrictionLifecycle, string> = {
    scheduled: "Scheduled",
    active: "Active",
    expired: "Expired",
};

// Expired is shown, not hidden — an admin needs to see why a rule stopped
// applying — so it needs a colour that reads as "no longer in force" rather
// than as an error.
const LIFECYCLE_COLOR: Record<RestrictionLifecycle, ComponentColor> = {
    scheduled: ComponentColor.Warning,
    active: ComponentColor.Success,
    expired: ComponentColor.Ghost,
};

interface RuleStatusBadgeProps {
    lifecycle: RestrictionLifecycle;
}

export const RuleStatusBadge = ({ lifecycle }: RuleStatusBadgeProps) => (
    <Badge color={LIFECYCLE_COLOR[lifecycle]} size={ComponentSize.SM}>
        {LIFECYCLE_LABEL[lifecycle]}
    </Badge>
);
